import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllMetalsBackoffice: build.query<
      GetAllMetalsBackofficeApiResponse,
      GetAllMetalsBackofficeApiArg
    >({
      query: () => ({ url: `/financeservice/v1/Backoffice/metals` }),
    }),
    getAllFundsBackoffice: build.query<
      GetAllFundsBackofficeApiResponse,
      GetAllFundsBackofficeApiArg
    >({
      query: () => ({ url: `/financeservice/v1/Backoffice/funds` }),
    }),
    getAllCurrenciesBackoffice: build.query<
      GetAllCurrenciesBackofficeApiResponse,
      GetAllCurrenciesBackofficeApiArg
    >({
      query: () => ({ url: `/financeservice/v1/Backoffice/currencies` }),
    }),
    saveCurrencies: build.mutation<
      SaveCurrenciesApiResponse,
      SaveCurrenciesApiArg
    >({
      query: () => ({
        url: `/financeservice/v1/Currencies/save`,
        method: 'POST',
      }),
    }),
    getAllCurrencies: build.query<
      GetAllCurrenciesApiResponse,
      GetAllCurrenciesApiArg
    >({
      query: () => ({ url: `/financeservice/v1/Currencies/GetCurrencies` }),
    }),
    deleteFavoriteMetal: build.mutation<
      DeleteFavoriteMetalApiResponse,
      DeleteFavoriteMetalApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Favorites/FavMetal/${queryArg.metalId}:guid`,
        method: 'DELETE',
      }),
    }),
    addFavoriteMetal: build.mutation<
      AddFavoriteMetalApiResponse,
      AddFavoriteMetalApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Favorites/FavMetal`,
        method: 'POST',
        body: queryArg.favoriteMetalCreateRequest,
      }),
    }),
    deleteFavoriteFund: build.mutation<
      DeleteFavoriteFundApiResponse,
      DeleteFavoriteFundApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Favorites/FavFund/${queryArg.fundId}:guid`,
        method: 'DELETE',
      }),
    }),
    addFavoriteFund: build.mutation<
      AddFavoriteFundApiResponse,
      AddFavoriteFundApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Favorites/FavFund`,
        method: 'POST',
        body: queryArg.favoriteFundCreateRequest,
      }),
    }),
    updateFundAsync: build.mutation<
      UpdateFundAsyncApiResponse,
      UpdateFundAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Funds/${queryArg.fundId}`,
        method: 'PUT',
        body: queryArg.fundUpdateRequest,
      }),
    }),
    getFundAsync: build.query<GetFundAsyncApiResponse, GetFundAsyncApiArg>({
      query: (queryArg) => ({
        url: `/financeservice/v1/Funds/${queryArg.fundId}`,
      }),
    }),
    deleteFundAsync: build.mutation<
      DeleteFundAsyncApiResponse,
      DeleteFundAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Funds/${queryArg.fundId}`,
        method: 'DELETE',
      }),
    }),
    saveFunds: build.mutation<SaveFundsApiResponse, SaveFundsApiArg>({
      query: () => ({ url: `/financeservice/v1/Funds/save`, method: 'POST' }),
    }),
    getAllFunds: build.query<GetAllFundsApiResponse, GetAllFundsApiArg>({
      query: () => ({ url: `/financeservice/v1/Funds/GetAllFunds` }),
    }),
    createFundAsync: build.mutation<
      CreateFundAsyncApiResponse,
      CreateFundAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Funds`,
        method: 'POST',
        body: queryArg.fundCreateRequest,
      }),
    }),
    triggerAsync: build.mutation<TriggerAsyncApiResponse, TriggerAsyncApiArg>({
      query: () => ({
        url: `/financeservice/v1/Jobs/finance-data-sync/trigger`,
        method: 'POST',
      }),
    }),
    updateMetalAsync: build.mutation<
      UpdateMetalAsyncApiResponse,
      UpdateMetalAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Metals/${queryArg.metalId}`,
        method: 'PUT',
        body: queryArg.metalUpdateRequest,
      }),
    }),
    getMetalAsync: build.query<GetMetalAsyncApiResponse, GetMetalAsyncApiArg>({
      query: (queryArg) => ({
        url: `/financeservice/v1/Metals/${queryArg.metalId}`,
      }),
    }),
    deleteMetalAsync: build.mutation<
      DeleteMetalAsyncApiResponse,
      DeleteMetalAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Metals/${queryArg.metalId}`,
        method: 'DELETE',
      }),
    }),
    saveMetals: build.mutation<SaveMetalsApiResponse, SaveMetalsApiArg>({
      query: () => ({ url: `/financeservice/v1/Metals/save`, method: 'POST' }),
    }),
    getAllMetals: build.query<GetAllMetalsApiResponse, GetAllMetalsApiArg>({
      query: () => ({ url: `/financeservice/v1/Metals/GetAllMetals` }),
    }),
    createMetalAsync: build.mutation<
      CreateMetalAsyncApiResponse,
      CreateMetalAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Metals`,
        method: 'POST',
        body: queryArg.metalCreateRequest,
      }),
    }),
    uploadStatementAsync: build.mutation<
      UploadStatementAsyncApiResponse,
      UploadStatementAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements/upload`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    parseEkstre: build.mutation<ParseEkstreApiResponse, ParseEkstreApiArg>({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements/parse`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getMonthlyCountsAsync: build.query<
      GetMonthlyCountsAsyncApiResponse,
      GetMonthlyCountsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements/monthly-counts`,
        params: {
          year: queryArg.year,
        },
      }),
    }),
    getStatementsAsync: build.query<
      GetStatementsAsyncApiResponse,
      GetStatementsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements`,
        params: {
          year: queryArg.year,
          month: queryArg.month,
        },
      }),
    }),
    getStatementDetailAsync: build.query<
      GetStatementDetailAsyncApiResponse,
      GetStatementDetailAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements/${queryArg.id}`,
      }),
    }),
    getCategories: build.query<GetCategoriesApiResponse, GetCategoriesApiArg>({
      query: () => ({ url: `/financeservice/v1/Statements/categories` }),
    }),
    analyzeEkstre: build.mutation<
      AnalyzeEkstreApiResponse,
      AnalyzeEkstreApiArg
    >({
      query: (queryArg) => ({
        url: `/financeservice/v1/Statements/analyze`,
        method: 'POST',
        body: queryArg.analyzeEkstreRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as finance };
export type GetAllMetalsBackofficeApiResponse =
  /** status 200 OK */ MetalViewModel[];
export type GetAllMetalsBackofficeApiArg = void;
export type GetAllFundsBackofficeApiResponse =
  /** status 200 OK */ FundViewModelRead[];
export type GetAllFundsBackofficeApiArg = void;
export type GetAllCurrenciesBackofficeApiResponse =
  /** status 200 OK */ CurrencyViewModel[];
export type GetAllCurrenciesBackofficeApiArg = void;
export type SaveCurrenciesApiResponse = unknown;
export type SaveCurrenciesApiArg = void;
export type GetAllCurrenciesApiResponse =
  /** status 200 OK */ CurrencyViewModel[];
export type GetAllCurrenciesApiArg = void;
export type DeleteFavoriteMetalApiResponse = unknown;
export type DeleteFavoriteMetalApiArg = {
  metalId: string;
};
export type AddFavoriteMetalApiResponse = /** status 201 Created */ string;
export type AddFavoriteMetalApiArg = {
  favoriteMetalCreateRequest: FavoriteMetalCreateRequest;
};
export type DeleteFavoriteFundApiResponse = unknown;
export type DeleteFavoriteFundApiArg = {
  fundId: string;
};
export type AddFavoriteFundApiResponse = /** status 201 Created */ string;
export type AddFavoriteFundApiArg = {
  favoriteFundCreateRequest: FavoriteFundCreateRequest;
};
export type UpdateFundAsyncApiResponse = /** status 200 OK */ string;
export type UpdateFundAsyncApiArg = {
  fundId: string;
  fundUpdateRequest: FundUpdateRequest;
};
export type GetFundAsyncApiResponse = /** status 200 OK */ FundViewModelRead;
export type GetFundAsyncApiArg = {
  fundId: string;
};
export type DeleteFundAsyncApiResponse = unknown;
export type DeleteFundAsyncApiArg = {
  fundId: string;
};
export type SaveFundsApiResponse = unknown;
export type SaveFundsApiArg = void;
export type GetAllFundsApiResponse = /** status 200 OK */ FundViewModelRead[];
export type GetAllFundsApiArg = void;
export type CreateFundAsyncApiResponse = /** status 201 Created */ string;
export type CreateFundAsyncApiArg = {
  fundCreateRequest: FundCreateRequest;
};
export type TriggerAsyncApiResponse = unknown;
export type TriggerAsyncApiArg = void;
export type UpdateMetalAsyncApiResponse = /** status 200 OK */ string;
export type UpdateMetalAsyncApiArg = {
  metalId: string;
  metalUpdateRequest: MetalUpdateRequest;
};
export type GetMetalAsyncApiResponse = /** status 200 OK */ MetalViewModel;
export type GetMetalAsyncApiArg = {
  metalId: string;
};
export type DeleteMetalAsyncApiResponse = unknown;
export type DeleteMetalAsyncApiArg = {
  metalId: string;
};
export type SaveMetalsApiResponse = unknown;
export type SaveMetalsApiArg = void;
export type GetAllMetalsApiResponse = /** status 200 OK */ MetalViewModel[];
export type GetAllMetalsApiArg = void;
export type CreateMetalAsyncApiResponse = /** status 201 Created */ string;
export type CreateMetalAsyncApiArg = {
  metalCreateRequest: MetalCreateRequest;
};
export type UploadStatementAsyncApiResponse = /** status 200 OK */ boolean;
export type UploadStatementAsyncApiArg = {
  body: {
    file: Blob;
  };
};
export type ParseEkstreApiResponse =
  /** status 200 OK */ EkstreParseResponseDto;
export type ParseEkstreApiArg = {
  body: {
    file: Blob;
  };
};
export type GetMonthlyCountsAsyncApiResponse =
  /** status 200 OK */ StatementMonthlyCountViewModel[];
export type GetMonthlyCountsAsyncApiArg = {
  year: number;
};
export type GetStatementsAsyncApiResponse =
  /** status 200 OK */ StatementListItemViewModel[];
export type GetStatementsAsyncApiArg = {
  year: number;
  month: number;
};
export type GetStatementDetailAsyncApiResponse =
  /** status 200 OK */ StatementDetailViewModel;
export type GetStatementDetailAsyncApiArg = {
  id: string;
};
export type GetCategoriesApiResponse =
  /** status 200 OK */ StatementCategoryItem[];
export type GetCategoriesApiArg = void;
export type AnalyzeEkstreApiResponse =
  /** status 200 OK */ EkstreAnalyzeResponseDto;
export type AnalyzeEkstreApiArg = {
  analyzeEkstreRequest: AnalyzeEkstreRequest;
};
export type CategoryIcon = {
  iconName?: string | null;
  color?: string | null;
  iconSize?: string | null;
};
export type MetalViewModel = {
  id?: string;
  code?: string | null;
  name?: string | null;
  updateAt?: string;
  buyingRate?: number;
  sellingRate?: number;
  dailyChangePercentage?: number;
  isFavorite?: boolean;
  icon?: CategoryIcon;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type FundViewModel = {
  id?: string;
  code?: string | null;
  name?: string | null;
  updateAt?: string;
  buyingRate?: number;
  sellingRate?: number;
  dailyChangePercentage?: number;
  investorCount?: number | null;
  payPrice?: number | null;
  fundSize?: number | null;
  priceUpdateTime?: string | null;
  lastUpdateTime?: string | null;
  performance1Day?: number | null;
  performance1Month?: number | null;
  performance3Months?: number | null;
  performance6Months?: number | null;
  performance1Year?: number | null;
};
export type FundViewModelRead = {
  id?: string;
  code?: string | null;
  name?: string | null;
  updateAt?: string;
  buyingRate?: number;
  sellingRate?: number;
  dailyChangePercentage?: number;
  investorCount?: number | null;
  payPrice?: number | null;
  fundSize?: number | null;
  priceUpdateTime?: string | null;
  lastUpdateTime?: string | null;
  performance1Day?: number | null;
  performance1Month?: number | null;
  performance3Months?: number | null;
  performance6Months?: number | null;
  performance1Year?: number | null;
  isFavorite?: boolean;
};
export type CurrencyViewModel = {
  id?: string;
  code?: string | null;
  name?: string | null;
  updateAt?: string;
  buyingRate?: number;
  sellingRate?: number;
  dailyChangePercentage?: number;
};
export type FavoriteMetalCreateRequest = {
  metalId?: string;
};
export type FavoriteFundCreateRequest = {
  fundId?: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type FundUpdateRequest = {
  /** Code of the fund */
  code?: string | null;
  /** Name of the fund */
  name?: string | null;
  /** Selling rate of the fund */
  sellingRate?: number;
  /** Buying rate of the fund */
  buyingRate?: number;
  /** Daily change percentage of the fund */
  dailyChangePercentage?: number;
};
export type FundCreateRequest = {
  /** Code of the fund */
  code?: string | null;
  /** Name of the fund */
  name?: string | null;
  /** Selling rate of the fund */
  sellingRate?: number;
  /** Buying rate of the fund */
  buyingRate?: number;
  /** Daily change percentage of the fund */
  dailyChangePercentage?: number;
};
export type MetalUpdateRequest = {
  /** Code of the metal */
  code?: string | null;
  /** Name of the metal */
  name?: string | null;
  /** Selling rate of the metal */
  sellingRate?: number;
  /** Buying rate of the metal */
  buyingRate?: number;
  /** Daily change percentage of the metal */
  dailyChangePercentage?: number;
};
export type MetalCreateRequest = {
  /** Code of the metal */
  code?: string | null;
  /** Name of the metal */
  name?: string | null;
  /** Selling rate of the metal */
  sellingRate?: number;
  /** Buying rate of the metal */
  buyingRate?: number;
  /** Daily change percentage of the metal */
  dailyChangePercentage?: number;
};
export type EkstreUnidentifiedTransactionDto = {
  title?: string | null;
  amount?: number;
  count?: number;
  category?: string | null;
};
export type EkstreTransactionDto = {
  title?: string | null;
  amount?: number;
  count?: number;
};
export type EkstreCategoryGroupDto = {
  category?: string | null;
  transactions?: EkstreTransactionDto[] | null;
  total_amount?: number;
  total_transaction_count?: number;
};
export type EkstreParseResponseDto = {
  unidentified_transactions?: EkstreUnidentifiedTransactionDto[] | null;
  categories?: EkstreCategoryGroupDto[] | null;
  total_transaction_count?: number;
};
export type StatementMonthlyCountViewModel = {
  month?: number;
  count?: number;
};
export type StatementListItemViewModel = {
  id?: string;
  fileName?: string | null;
  uploadedAt?: string;
  totalAmount?: number;
  transactionCount?: number;
};
export type SpendingCategoryViewModel = {
  categoryName?: string | null;
  amount?: number;
  percentage?: number;
};
export type StatementDetailViewModel = {
  id?: string;
  fileName?: string | null;
  uploadedAt?: string;
  totalAmount?: number;
  transactionCount?: number;
  highestCategory?: string | null;
  savingsPotential?: number;
  spendingCategories?: SpendingCategoryViewModel[] | null;
  aiRecommendations?: string[] | null;
};
export type StatementCategoryItem = {
  key?: string | null;
  label?: string | null;
};
export type EkstreRecommendationDto = {
  category?: string | null;
  advice?: string | null;
  potential_annual_saving?: number;
};
export type EkstreAnalyzeResponseDto = {
  categories?: EkstreCategoryGroupDto[] | null;
  total_spending?: number;
  top_category?: string | null;
  total_transaction_count?: number;
  recommendations?: EkstreRecommendationDto[] | null;
  total_potential_annual_saving?: number;
};
export type AnalyzeEkstreRequest = {
  categories?: EkstreCategoryGroupDto[] | null;
  total_transaction_count?: number;
  file_name?: string | null;
  month?: number;
  year?: number;
};
export const {
  useGetAllMetalsBackofficeQuery,
  useGetAllFundsBackofficeQuery,
  useGetAllCurrenciesBackofficeQuery,
  useSaveCurrenciesMutation,
  useGetAllCurrenciesQuery,
  useDeleteFavoriteMetalMutation,
  useAddFavoriteMetalMutation,
  useDeleteFavoriteFundMutation,
  useAddFavoriteFundMutation,
  useUpdateFundAsyncMutation,
  useGetFundAsyncQuery,
  useDeleteFundAsyncMutation,
  useSaveFundsMutation,
  useGetAllFundsQuery,
  useCreateFundAsyncMutation,
  useTriggerAsyncMutation,
  useUpdateMetalAsyncMutation,
  useGetMetalAsyncQuery,
  useDeleteMetalAsyncMutation,
  useSaveMetalsMutation,
  useGetAllMetalsQuery,
  useCreateMetalAsyncMutation,
  useUploadStatementAsyncMutation,
  useParseEkstreMutation,
  useGetMonthlyCountsAsyncQuery,
  useGetStatementsAsyncQuery,
  useGetStatementDetailAsyncQuery,
  useGetCategoriesQuery,
  useAnalyzeEkstreMutation,
} = injectedRtkApi;
